import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { Event, NavigationEnd, NavigationStart, Router, RouterModule } from '@angular/router';
import { PageLoaderComponent } from './layout/page-loader/page-loader.component';
import { Subject, takeUntil } from 'rxjs';
import { NotificationRealtimeService } from '@core/service/notification-realtime.service';
import { AuthManagementService } from '@core/service/auth-management.service';
import { NavigationHistoryService } from '@core/service/navigation-history.service';
import { CookiesConsentComponent } from '@shared/components/cookies-consent/cookies-consent.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    PageLoaderComponent,
    CookiesConsentComponent,
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnDestroy {

  currentUrl!: string;

  private readonly destroy$ = new Subject<void>();

  constructor(
    public _router: Router,
    private realtimeNoti: NotificationRealtimeService,
    public auth: AuthManagementService,
    private navigationHistory: NavigationHistoryService
  ) {
    this.realtimeNoti.init();
    this.realtimeNoti.ensureConnected();

    this._router.events
      .pipe(takeUntil(this.destroy$))
      .subscribe((routerEvent: Event) => {

        if (routerEvent instanceof NavigationStart) {
          this.currentUrl = routerEvent.url.substring(
            routerEvent.url.lastIndexOf('/') + 1
          );
        }

        if (routerEvent instanceof NavigationEnd) {
          this.navigationHistory.setCurrentUrl(routerEvent.urlAfterRedirects);
        }
        window.scrollTo(0, 0);
      });
  }

  ngOnDestroy(): void {

    this.destroy$.next();
    this.destroy$.complete();

  }

  get shouldShowCookiesConsent(): boolean {
    return this.auth.isAuthenticated();
  }

}
